import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { UseFormReturn } from 'react-hook-form';
import { AddTestForm, Resource } from 'shared/types';
import AddCustomQueryTestWizardStages from './AddCustomQueryTestWizardStages';
import WizardConfigurationStage from './WizardConfigurationStage';
import WizardStage from './WizardStage';

const Wrapper = styled(Flex)`
  height: 100%;
  overflow: auto;
`;

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
  stage: number;
  isCustomQuery?: boolean;
  singularTestPaths?: string[];
  tableResourcesData?: Resource[];
  isDataTestsEnabled: boolean;
};

const PlanEditTestWizardStages = ({
  methods,
  stage,
  isCustomQuery,
  singularTestPaths,
  tableResourcesData,
  isDataTestsEnabled,
}: Props) => (
  <Wrapper>
    <WizardStage
      $index={1}
      $selectedIndex={stage}
      $fillHeight={methods.watch('testType') === 'yamlTest'}
    >
      {isCustomQuery ? (
        <AddCustomQueryTestWizardStages
          methods={methods}
          singularTestPaths={singularTestPaths}
          tableResourcesData={tableResourcesData}
          isDataTestsEnabled={isDataTestsEnabled}
          // Jinja cannot be table-translated; only use sql mode when raw SQL is present.
          codeType={methods.watch('customQueryCodeType') ?? 'sql'}
        />
      ) : (
        <WizardConfigurationStage methods={methods} skipDefaults />
      )}
    </WizardStage>
  </Wrapper>
);

export default PlanEditTestWizardStages;
